export default __webpack_public_path__ + "static/media/landing-page-head-img-4.3b819900.jpg";